<template>
    <div class="page">
        <div class="weui-msg">
            <div class="weui-msg__icon-area"><i class="weui-icon-waiting weui-icon_msg"></i></div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">欢迎乐捐</h2>
                <p class="weui-msg__desc">如果您愿意，那就乐捐1分钱支持一下校圆通的开发团队吧，只接受1分钱，1分也是爱^=^啦啦~~</p>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <a href="javascript:;" class="weui-btn weui-btn_primary" @click="donate">马上乐捐1分钱</a>
                </p>
            </div>
            <div class="weui-msg__extra-area">
                <div class="weui-footer">
                    <p class="weui-footer__links">
                        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
                    </p>
                    <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      year: moment().format("YYYY"),
      token: ""
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    donate() {
      axios
        .get("/api/common/donate")
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    }
  }
};
</script>

<style scoped>
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/actives/donate.vue